import React, { useState, useEffect } from 'react';
import Layout from '../layout/Layout';
import { PrivateAxios } from '../../request/axios';
import { toast } from 'react-toastify';

const CreerINT = () => {
    const [ugList, setUgList] = useState([]);
    const [formData, setFormData] = useState({
        nom: '',
        description: '',
        intitule: '',
        adresse: '',
        code_postal: '',
        ville: '',
        ridet: '',
        tel: '',
        email: ''
    });

    const [ugId, setUgId] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [loadingUG, setLoadingUG] = useState(true);
    const [error, setError] = useState(null);

    // Fonction pour récupérer la liste des UG
    const fetchUGs = async () => {
        try {
            const response = await PrivateAxios.get('/admin/ug');
            setUgList(response.data.ug);
            setLoadingUG(false);
        } catch (err) {
            setError('Erreur lors du chargement des UG.');
            toast.error('Erreur lors du chargement des UG.');
            setLoadingUG(false);
        }
    };

    // Appel de fetchUGs au chargement du composant
    useEffect(() => {
        fetchUGs();
    }, []);

    // Fonction générique pour gérer les changements de champs
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value
        }));
    };

    // Fonction pour gérer la soumission du formulaire
    const handleSubmit = async (e) => {
        e.preventDefault();

        const requiredFields = ['nom', 'description', 'intitule', 'adresse', 'code_postal', 'ville', 'ridet', 'tel', 'email'];
        for (let field of requiredFields) {
            if (!formData[field]) {
                toast.error(`Le champ ${field.replace('_', ' ')} est obligatoire.`);
                return;
            }
        }

        if (!ugId) {
            toast.error("L'UG d'affectation est obligatoire.");
            return;
        }

        setIsSubmitting(true);

        const payload = {
            ...formData,
            ug_id: ugId,
        };

        try {
            await PrivateAxios.post('/admin/intermediaire', payload);
            toast.success("L'intermédiaire a été créé avec succès !");
            // Réinitialiser les champs du formulaire après succès
            setFormData({
                nom: '',
                description: '',
                intitule: '',
                adresse: '',
                code_postal: '',
                ville: '',
                ridet: '',
                tel: '',
                email: ''
            });
            setUgId('');
        } catch (err) {
            toast.error("Erreur lors de la création de l'intermédiaire.");
        } finally {
            setIsSubmitting(false);
        }
    };

    // Fonction générique pour générer les champs du formulaire
    const renderInputField = (id, label, placeholder, type = 'text', required = true) => (
        <div className="mb-4">
            <label className="block mb-2 text-sm font-bold text-gray-700" htmlFor={id}>
                {label}
            </label>
            <input
                id={id}
                name={id}
                type={type}
                value={formData[id]}
                onChange={handleInputChange}
                placeholder={placeholder}
                required={required}
                className="w-full px-3 py-2 transition-all duration-300 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500"
            />
        </div>
    );

    return (
        <Layout>
            <h1 className="mb-8 text-3xl font-bold text-center text-black">Ajout d'un intermédiaire</h1>

            <div className="flex justify-center">
                <form
                    onSubmit={handleSubmit}
                    className="w-full max-w-4xl p-8 transition-all duration-500 bg-white rounded-lg shadow-md hover:shadow-lg"
                >
                    <div className="grid grid-cols-2 gap-6">
                        {/* Utilisation de la fonction générique pour les champs */}
                        {renderInputField('nom', "Nom de l'intermédiaire", "00001")}
                        {renderInputField('description', "Description de l'intermédiaire", "Entrez une description", 'textarea')}
                        {renderInputField('intitule', "Intitulé", "Axa...")}
                        {renderInputField('adresse', "Adresse", "Entrez l'adresse")}
                        {renderInputField('code_postal', "Code Postal", "Entrez le code postal")}
                        {renderInputField('ville', "Ville", "Entrez la ville")}
                        {renderInputField('ridet', "Ridet", "Entrez le RIDET")}
                        {renderInputField('tel', "Téléphone", "Entrez le numéro de téléphone", "number")}
                        {renderInputField('email', "Email", "Entrez l'email", "email")}

                        {/* Champ UG d'affectation */}
                        <div className="block">
                            <label className="block mb-2 text-sm font-bold text-gray-700" htmlFor="ugId">
                                UG d'affectation
                            </label>
                            {loadingUG ? (
                                <p className="text-gray-500">Chargement des UG...</p>
                            ) : (
                                <select
                                    id="ugId"
                                    value={ugId}
                                    onChange={(e) => setUgId(e.target.value)}
                                    required
                                    className="w-full px-3 py-2 transition-all duration-300 border rounded-lg shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500"
                                >
                                    <option value="">Sélectionner une UG</option>
                                    {ugList.map((ug) => (
                                        <option key={ug.id} value={ug.id}>
                                            {ug.nom}
                                        </option>
                                    ))}
                                </select>
                            )}
                        </div>
                    </div>

                    {/* Bouton de soumission */}
                    <div className="flex justify-center mt-6">
                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className={`w-1/2 px-4 py-2 bg-blue-600 text-white font-bold rounded-lg shadow-md hover:bg-blue-700 focus:outline-none transition-all duration-300 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}`}
                        >
                            {isSubmitting ? 'Création en cours...' : 'Créer l\'intermédiaire'}
                        </button>
                    </div>
                </form>
            </div>

            {/* Affichage des erreurs */}
            {error && <p className="mt-4 text-center text-red-500">{error}</p>}
        </Layout>
    );
};

export default CreerINT;
